import React from 'react';

const BorderBox = ({className, children, isSmall = false}) => {
  return <div className={`${className} border-box`}>
    {children}
    <div className={`top-left ${isSmall && 'small'}`}></div>
    <div className={`top-right ${isSmall && 'small'}`}></div>
    <div className={`bottom-right ${isSmall && 'small'}`}></div>
    <div className={`bottom-left ${isSmall && 'small'}`}></div>
  </div>;
};

export const BorderBox2 = ({children}) => {
  return <div className={'border-box w-fit'}>
    {children}
    <div className={'top-left x-small'}></div>
    <div className={'top-right x-small'}></div>
    <div className={'bottom-right x-small'}></div>
    <div className={'bottom-left x-small'}></div>
  </div>;
};

export default BorderBox;